import { useState } from 'react';
import { CopyButton } from '@nyce/admin-kit/console';
import { saveBlob } from '@nyce/admin-kit/api';
import { Button } from '@nyce/admin-kit/ui';
import { Tabs } from '../../components/common';
import type { GeneratedFile } from '../generate/files';
import { zip } from '../generate/zip';
import { PLACEHOLDER } from './secrets';

const save = (name: string, data: BlobPart, type: string) => saveBlob(new Blob([data], { type }), name);

/** Copy a text to the clipboard; the button says so for a moment (the kit's). */
export { CopyButton };

/**
 * Generated config files (decision 4): a tab per file, its content, copy and download, and all of them as one zip.
 * Secrets issued in this wizard are in the files; after a reload they show the placeholder instead.
 */
export function FileOutput({ files, zipName }: { files: GeneratedFile[]; zipName?: string }) {
  const [open, setOpen] = useState(files[0]?.name ?? '');
  const file = files.find((f) => f.name === open) ?? files[0];
  if (!file) return null;
  const hasPlaceholder = files.some((f) => f.content.includes(PLACEHOLDER));
  return (
    <div className="ob-files" data-testid="file-output">
      {files.length > 1 && (
        <Tabs
          value={file.name}
          onChange={setOpen}
          options={files.map((f) => ({ value: f.name, label: f.name }))}
        />
      )}
      {file.note && <p className="nyk-ui-hint ob-file-note">{file.note}</p>}
      <pre className="ob-file" data-file={file.name}>
        {file.content}
      </pre>
      {hasPlaceholder && (
        <p className="nyk-ui-hint" data-testid="secret-placeholder">
          {PLACEHOLDER} marks a secret that was issued before this page was opened: issue a new one in its
          step, or paste it on site.
        </p>
      )}
      <div className="nyk-row-actions">
        <CopyButton text={file.content} />
        <Button
          size="sm"
          variant="ghost"
          onClick={() => save(file.name, file.content, 'text/plain;charset=utf-8')}
        >
          Download {file.name}
        </Button>
        {files.length > 1 && zipName && (
          <Button size="sm" variant="ghost" onClick={() => save(zipName, zip(files), 'application/zip')}>
            Download all (.zip)
          </Button>
        )}
      </div>
    </div>
  );
}
